"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLOR = exports.BORDER_WIDTH = exports.BORDER_RADIUS = exports.BUTTON_TYPE = exports.LABEL_TEXT_ALIGN = exports.LABEL_FONT_WEIGHT = exports.LABEL_FONT_SIZE = exports.SPACE_SIZE = void 0;

const createEnum = keys => Object.fromEntries(keys.map(key => [key, key]));
/**
 * Unified space sizes between components and elements
 *
 * Specific size depends on a theme:
 * @see src/components/themes/
 */


const SPACE_SIZE = {
  none: 'none',
  micro: 'micro',
  xxsmall: 'xxsmall',
  xsmall: 'xsmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  xxlarge: 'xxlarge'
};
exports.SPACE_SIZE = SPACE_SIZE;
const LABEL_FONT_SIZE = createEnum(['xsmall', 'small', 'medium', 'large', 'xlarge']);
exports.LABEL_FONT_SIZE = LABEL_FONT_SIZE;
const LABEL_FONT_WEIGHT = createEnum(['normal', 'semibold']);
exports.LABEL_FONT_WEIGHT = LABEL_FONT_WEIGHT;
const LABEL_TEXT_ALIGN = createEnum(['start', 'end', 'center', 'justify']);
exports.LABEL_TEXT_ALIGN = LABEL_TEXT_ALIGN;
const BUTTON_TYPE = {
  default: 'default',
  text: 'text',
  secondary: 'secondary',
  tertiary: 'tertiary',
  quaternary: 'quaternary',
  quinary: 'quinary',
  error: 'error'
};
/**
 * Unified border radiuses available to set in components
 *
 * Specific value depends on a theme:
 * @see src/components/themes/
 */

exports.BUTTON_TYPE = BUTTON_TYPE;
const BORDER_RADIUS = {
  none: 'none',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge',
  xxlarge: 'xxlarge'
};
exports.BORDER_RADIUS = BORDER_RADIUS;
const BORDER_WIDTH = {
  none: 'none',
  thin: 'thin',
  medium: 'medium',
  thick: 'thick'
};
/**
 * Unified colors available to change in components
 *
 * Specific color values depends on a theme:
 * @see src/components/themes/
 */

exports.BORDER_WIDTH = BORDER_WIDTH;
const COLOR = {
  primary: 'primary',
  secondary: 'secondary',
  accent: 'accent',
  tertiary: 'tertiary',
  white: 'white',
  black: 'black',
  gray: 'gray',
  red: 'red'
};
exports.COLOR = COLOR;